const noteTypeMapping = [
  {
    id: 'household',
    name: 'Household',
    ordinal: 0,
  },
  {
    id: 'meeting',
    name: 'Meetings',
    ordinal: 1,
  },
];

export default noteTypeMapping;
